import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeGallery() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper mb-lg-4"
            >
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/g1.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/g1.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/g2.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/g2.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/g3.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/g3.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/g4.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/g4.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>



                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/g5.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/g5.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/01.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/01.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/02.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/02.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/03.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/03.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/04.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/04.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/05.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/05.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/06.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/06.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/07.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/07.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/08.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/08.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/09.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/09.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/10.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/10.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/11.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/11.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/12.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/12.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/13.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/13.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/14.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/14.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/15.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/15.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/16.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/16.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/17.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/17.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/18.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/18.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/19.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/19.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/20.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/20.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/21.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/21.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/22.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/22.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/23.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/23.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/24.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/24.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/25.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/25.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/26.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/26.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/27.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/27.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/28.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/28.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/29.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/29.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="owl-item cloned" >
                        <div className="portfolio-item">
                            <div className="portfolio-img">
                                <img className="img-fluid" src="assets/yog/30.webp" alt />
                                <Link className="popup-img portfolio-link" to="assets/yog/30.webp"> <i className="far fa-plus" /></Link>
                            </div>
                            <div className="portfolio-content">
                                <div className="portfolio-info">
                                    <h4><Link to="/gallery">Explore More</Link></h4>
                                </div>
                                <Link to="/gallery" className="portfolio-arrow"><i className="fas fa-arrow-right" /></Link>
                            </div>
                        </div></div>
                </SwiperSlide>
               
             



            </Swiper>
        </>
    );
}
